/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAppointmentResponse } from './CreateAppointmentResponse';
import {
    CreateAppointmentResponseFromJSON,
    CreateAppointmentResponseFromJSONTyped,
    CreateAppointmentResponseToJSON,
    CreateAppointmentResponseToJSONTyped,
} from './CreateAppointmentResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateAppointmentResponse
 */
export interface ResultOfCreateAppointmentResponse {
    /**
     * 
     * @type {CreateAppointmentResponse}
     * @memberof ResultOfCreateAppointmentResponse
     */
    data: CreateAppointmentResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateAppointmentResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateAppointmentResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateAppointmentResponse interface.
 */
export function instanceOfResultOfCreateAppointmentResponse(value: object): value is ResultOfCreateAppointmentResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateAppointmentResponseFromJSON(json: any): ResultOfCreateAppointmentResponse {
    return ResultOfCreateAppointmentResponseFromJSONTyped(json, false);
}

export function ResultOfCreateAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateAppointmentResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateAppointmentResponseToJSON(json: any): ResultOfCreateAppointmentResponse {
    return ResultOfCreateAppointmentResponseToJSONTyped(json, false);
}

export function ResultOfCreateAppointmentResponseToJSONTyped(value?: ResultOfCreateAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateAppointmentResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

